import request from '@/utils/request';
import {
  rqRegister,
  rqLogin,
  rpLogin,
  ResponseCommon,
  User,
  rpUserList,
  rpUser,
  UserListParams,
  rpCheckUsername,
  rpUserBalance
} from './type';
import useStore from '@/store';

export function register(data: rqRegister): Promise<ResponseCommon> {
  return request({
    url: '/api/auth/register',
    method: 'post',
    data: data
  });
}

export function loginWeb(data: rqLogin): Promise<rpLogin> {
  return request({
    url: '/api/auth/login',
    method: 'post',
    data: data
  });
}

// 获取用户列表
export const getUserList = (params?: UserListParams): Promise<rpUserList> => {
  return request({
    url: '/api/users',
    method: 'get',
    params
  });
};

// 获取单个用户
export const getUserById = (id: number) => {
  return request({
    url: `/api/users/${id}`,
    method: 'get'
  });
};

// 创建用户
export const createUser = (data: Omit<User, 'id' | 'created_at' | 'updated_at'>) => {
  return request({
    url: '/api/users',
    method: 'post',
    data
  });
};

// 更新用户
export const updateUser = (id: number, data: Partial<User>) => {
  return request({
    url: `/api/users/${id}`,
    method: 'put',
    data
  });
};

// 删除用户
export const deleteUser = (id: number) => {
  return request({
    url: `/api/users/${id}`,
    method: 'delete'
  });
};

// 更新用户状态
export const updateUserStatus = (id: number, status: User['status']) => {
  return request({
    url: `/api/users/${id}/status`,
    method: 'put',
    data: { status }
  });
};

// 检查用户名是否存在
export const checkUsername = (username: string): Promise<rpCheckUsername> => {
  return request({
    url: `/api/users/check-username?username=${username}`,
    method: 'get'
  });
};
// 获取用户余额
export const getUserBalance = (username: string): Promise<rpUserBalance> => {
  return request({
    url: `/api/users/balance?username=${username}`,
    method: 'get'
  });
};
